import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'

import { FormRow, Col } from '../../../../../../../1stlog-ui/src/components/Bootstrap'
import { useField, FeedbackBadge } from '../../../../../../../1stlog-ui/src/components/Field'
import i18next from 'i18next'

const validate = (value) =>
  value
    ? i18n.t(
        'if_limited_quantity_of_hazardgoods_total_weight_no_more_than_30_kg', 
        'Bei einer begrenzten Menge von Gefahrgütern darf das Gesamtgewicht des Colis 30 kg nicht übersteigen.')
    : undefined

const LimitedQuantity = (props) => {
  const { hazmats } = props

  const weight = useField('weight')

  const {
    input: { value: isLimitedQuantityInvalid, onChange: setIsLimitedQuantityInvalid },
    meta
  } = useField('validation.isLimitedQuantityInvalid', {
    raw: true,
    validate,
    subscribeAll: true
  })

  useEffect(() => {
    const isLq = lodash.some(hazmats, (h) => lodash.get(h, 'limitedQuantityEnabled'))
    const newIsLimitedQuantityInvalid = isLq && Number(weight) > 30
    if (!lodash.isEqual(isLimitedQuantityInvalid, newIsLimitedQuantityInvalid)) {
      setIsLimitedQuantityInvalid(newIsLimitedQuantityInvalid)
    }
  }, [weight, hazmats])

  return (
    isLimitedQuantityInvalid && (
      <FormRow>
        <Col>
          <FeedbackBadge meta={meta} />
        </Col>
      </FormRow>
    )
  )
}

export default LimitedQuantity
